import React, { useState, useEffect } from "react";
import axiosMain from "../../../http/axios/axios_main";
import CustomToast from "../../../components/Toast";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
function RedemptionRequest(props) {
  //  const [userCode, setUserCode] = useState("");
  const userCode = atob(sessionStorage.getItem("argument4"));
  const [openingBalance, setOpeningBalance] = useState("");
  const [redeemClicked, setRedeemClicked] = useState(false);
  const { auctionCenterId } = useAuctionDetail();
  //const [refundRequestDTO, setRefundRequestDTO] = useState(null);
  //const userId = parseInt(atob(sessionStorage.getItem("argument2"))) || "";
  useEffect(() => {
    axiosMain
      .get(`/postauction/allocateFund/getbuyerBalance/${auctionCenterId}`)
      .then((response) => {
        setOpeningBalance(response.data.responseData);
      })
      .catch((error) => {
        console.error("Error fetching buyer balance:", error);
      });
  }, []);

  const [url, setUrl] = useState("");
  const [baseUrl, setBaseUrl] = useState("");

  useEffect(() => {
    setUrl(window.location.href);

    let data = window.location.href.includes("auctionPage")
      ? window.location.href
          .split("auctionPage")
          [window.location.href.split("auctionPage").length - 1].split("/")
      : window.location.href
          .split("englishauction")
          [window.location.href.split("englishauction").length - 1].split("/");

    data.shift();
    let selectedData = data.slice(0, 4);

    setBaseUrl(String(selectedData.join("/")));
  }, [url]);

  const handleConfirmRedeem = async () => {
    try {
      const url = `/postauction/refundrequestset/${userCode}/${openingBalance}/${auctionCenterId}?baseUrl=${baseUrl}`;
      // const url = `/postauction/refundrequestset/${userCode}/${openingBalance}/${auctionCenterId}`;
      const response = await axiosMain.post(url);
      if (response.status === 200) {
        const responseData = response.data.responseData;
        let myForm = document.getElementById("form1");
        if (!myForm) {
          myForm = document.createElement("form");
          myForm.method = "post";
          myForm.action = responseData?.url;
          myForm.id = "form1";
          document.body.appendChild(myForm);
        } else {
          myForm.action = responseData?.url;
        }

        const formData = [
          {
            name: "walletClientCode",
            value: responseData?.clientcode,
          },
          {
            name: "walletRequestMessage",
            value: responseData?.encrptionKey,
          },
        ];

        // Update existing inputs or create them if they don't exist
        formData.forEach((field) => {
          let hiddenInput = myForm.querySelector(`input[name="${field.name}"]`);
          if (!hiddenInput) {
            // If the input doesn't exist, create it
            hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = field.name;
            myForm.appendChild(hiddenInput);
          }
          // Update the value of the input
          hiddenInput.value = field.value;
        });

        // Submit the form
        myForm.submit();
        // setRedeemClicked(true);
      } else {
        CustomToast.error("Service is not working. Try after some time.");
      }
    } catch (error) {
      CustomToast.error("Service is not working. Try after some time.");
    }
  };

  return (
    <div style={{ border: "1px solid black", padding: "10px", margin: "2px" }}>
      <p>
        OEPSS Balance :
        <input
          style={{ margin: "30px" }}
          type="text"
          id="balance"
          name="balance"
          //   onChange={handleChange}
          value={openingBalance}
          disabled={openingBalance !== ""}
        />
      </p>

      <div className="confirmation-modal">
        Are you sure you want to proceed with the Redemption Request?
        <button
          className="YesNoButton"
          style={{ margin: "30px" }}
          onClick={handleConfirmRedeem}
        >
          Redeem
        </button>
        <button className="YesNoButton" onClick={props.handleClose}>
          {" "}
          Cancel
        </button>
      </div>
      <p
        style={{
          fontWeight: "bold",
          marginTop: "10px",
          textDecoration: "underline",
        }}
      >
        Note:
      </p>
      <div>On confirmation, you will be redirected to the bank's website.</div>
      {redeemClicked && (
        <div className="loading-spinner">Loading...</div>
        //  <p style={{ color: "red" }}>Redirecting to the bank portal...</p>
      )}
    </div>
  );
}

export default RedemptionRequest;
